import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {Router} from '@angular/router';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {User} from '@models/user';
import {PromoPartner} from '@models/promo';
import {EMPTY_USER} from '@models/empty';
import {AccountComponent} from '@components/popup/account/account.component';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '@services/alert.service';
import {ConfirEndtrialComponent} from '@components/popup/confir-endtrial/confir-endtrial.component';

@Component({
    selector: 'app-endtrial',
    templateUrl: './endtrial.component.html',
    styleUrls: ['./endtrial.component.scss']
})
export class EndtrialComponent {

    user: User = Object.assign({}, EMPTY_USER);
    stripe = Stripe(environment.stripeKey);
    step = '1';
    promo = '';
    partner: PromoPartner = null;
    loading = false;
    duration = 'year';
    aiCreditTooltip = 'Décidez plus vite : notre IA analyse l’annonce et le DPE, met en lumière les opportunités, les alertes et les chiffres à vérifier, puis suggère les ajustements utiles pour fiabiliser votre investissement.';

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<EndtrialComponent>,
        private http: HttpClient,
        private alertService: AlertService,
        public userService: UserService,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
        this.user = this.authenticationService.currentUser;
        this.userService.getPromo().subscribe(res => {
            this.promo = res.promo;
            this.partner = res.partner || null;
        }, error => {
        });
    }

    nextStep() {
        this.step = '2';
    }

    onNoClick(): void {
        const dialogRef = this.dialog.open(ConfirEndtrialComponent, {
            width: '480px',
            data: {
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === false) {
                this.userService.closePopupEndtrial().subscribe(invoices => {
                    this.authenticationService.currentUser.news_form = true;
                    this.dialogRef.close(false);
                });
            }
        });
    }

    setDuration(duration) {
        this.duration = duration;
    }

    planSelect(plan) {
        if (this.loading == true) {
            return;
        }

        const dialogRef = this.dialog.open(AccountComponent, {
            width: '480px',
            data: {
                duration: this.duration,
                plan: plan,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.loading = true;
                this.duration = result;

                this.userService.closePopupEndtrial().subscribe(invoices => {
                    this.authenticationService.currentUser.news_form = true;
                });

                this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                    {plan, duration: this.duration}).subscribe(
                    session => {
                        // this.loading = false;
                        this.trackingService.checkout({value: plan});
                        this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                            if (result.error) {
                                alert(result.error.message);
                            }
                        });
                    },
                    (error) => {
                        console.log(error);
                        this.loading = false;
                        this.alertService.error('Erreur');
                    });
            }
        });
    }
}
